import React, { useState } from 'react';
import './Login.css';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username || !password) return;
    setError('');
    setLoading(true);
    try {
      // Validate the credentials AND learn the role in one call. Previously any username/password
      // "logged in" without checking — now the server confirms and tells us what to render.
      const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;
      const res = await fetch(`${apiEndpoint}/admin/whoami`, {
        headers: { 'Authorization': 'Basic ' + btoa(`${username}:${password}`) },
        cache: 'no-store',
      });
      if (res.status === 401 || res.status === 403) {
        setError('Incorrect username or password.');
        return;
      }
      if (!res.ok) {
        setError('Could not reach the server. Try again.');
        return;
      }
      const data = await res.json();
      const role = (data && data.role) || 'admin';
      localStorage.setItem('admin_username', username);
      localStorage.setItem('admin_password', password);
      localStorage.setItem('admin_role', role);
      onLogin(role);
    } catch (err) {
      setError('Could not reach the server. Try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>GenF Admin</h1>
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              autoCapitalize="none"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
            />
          </div>
          {error ? <p className="login-error">{error}</p> : null}
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Signing in…' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
